"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const recoil_1 = require("recoil");
const settingPCCStates_1 = require("@/common/components/DeliverySetting/DeliverySettingPCC/settingPCCStates");
const react_i18next_1 = require("react-i18next");
const material_ui_confirm_1 = require("material-ui-confirm");
const CircularProgress_1 = __importDefault(require("@mui/material/CircularProgress"));
const components_1 = require("@/member/setting/components");
const savePaymentDetailPCCSetting_1 = __importDefault(require("./savePaymentDetailPCCSetting"));
function default_1({ isPCCRegistering, setDeliverySettingData, settingPCCForm, }) {
    const isSubmitPCCPending = (0, recoil_1.useRecoilValue)(settingPCCStates_1.isSubmitPCCPendingState);
    const confirm = (0, material_ui_confirm_1.useConfirm)();
    const { t } = (0, react_i18next_1.useTranslation)();
    return ((0, jsx_runtime_1.jsx)(components_1.SettingRegisterButton, Object.assign({ sx: { display: isPCCRegistering ? 'flex' : 'none' }, onClick: (0, savePaymentDetailPCCSetting_1.default)({
            setDeliverySettingData,
            settingPCCForm,
            confirm,
        }) }, { children: isSubmitPCCPending ? ((0, jsx_runtime_1.jsx)(CircularProgress_1.default, { size: 12, color: "info", thickness: 6, sx: { margin: '0 6.5px' } })) : ((0, jsx_runtime_1.jsx)("span", { children: t('등록') })) })));
}
exports.default = default_1;
